import React, { FC, ReactNode } from "react";
import { Navbar, NavbarProps } from "./Navbar";
import styled from "styled-components";
import QuizModal from "../QuizModal";
import { useCourseFlow } from "flows";
import { Outlet } from "react-router-dom";
import { useAuth } from "hooks";
import { routeNames } from "utils";
import ProfileEdit, { ProfileEditProps } from "dashboard/ui/pages/ProfileEdit";

const Root = styled.div`
  width: 100vw;
  height: 100vh;
  overflow: auto;
  background: #fff;
`;
const Body = styled.div`
  display: flex;
  width: 100%;
  height: calc(100% - 70px);
`;

export interface DashboardLayoutProps extends Pick<ProfileEditProps, "onSave">{

}

export const DashboardLayout: FC<DashboardLayoutProps> = ({ onSave }) => {
  const flow = useCourseFlow();
  const authHook = useAuth();
  return (
    <Root>
      <Navbar {...{ onLogout: () => authHook.logout(routeNames.login) }}/>
      <Body>
        <Outlet/>
      </Body>
      <ProfileEdit {...{ onSave }}/>
      <QuizModal {...{
        onGetCorrectAnswers: flow.onGetCorrectAnswers, 
        onGetQuiz: flow.onGetQuiz,
        onGetQuestionAnswer: flow.onGetCorrectAnswer,
        async onComplete(userQuiz, quizAnswers) {
          return flow.onScoreQuiz({
            userQuiz, userQuestionAnswers: quizAnswers
          })
        }
      }}/>
    </Root>
  );
};
